export const enum Approaches {
    RetrieveThenRead = "rtr",
    ReadRetrieveRead = "rrr",
    ReadDecomposeAsk = "rda"
}

export const enum InteractionType {
    avatarAudioInput = "avatar_mobile_audio_input",
    chatExample = "chat_example",
    chatFollowUp = "chat_followup",
    chatAudioInput = "chat_audio_input",
    chatRegular = "chat_regular",
    chatRetry = "retry"
}

export type AskRequestOverrides = {
    quantile?: number;
    suggestFollowupQuestions?: boolean;
};

export type AskRequest = {
    question: string;
    approach: Approaches;
    overrides?: AskRequestOverrides;
};

export type LikeRequest = {
    conversation_id: string | null;
    iteration_id: string;
    like: boolean;
    reason: string;
};
// TODO: clean this up
/*
export type AskResponse = {
    answer: string;
    conversation_id: string;
    thoughts: string | string[] | null;
    iteration_id: string;
    data_points: string[] | null;
    error?: string;
};
*/

export type AskResponse = {
    chat_message: string; // answer
    conversation_id: string;
    // thoughts: string | string[] | null;
    // iteration_id: string;
    // data_points: string[] | null;
    // error?: string;
    user_message: string;
    message_date: string;
    email: string;
    frustration_history: boolean;
    name: string;
    phone: string;
    state: string;
};


export type ChatTurn = {
    user: string;
    bot?: string;
};

// TODO: clean this up
/*
export type ChatRequest = {
    history: ChatTurn[];
    approach: Approaches;
    interaction_type: InteractionType;
    is_avatar: boolean;
    is_avatar_sound: boolean;
    layout_width: string;
    layout: string;
    overrides?: AskRequestOverrides;
    conversation_id: string | null;
};
*/

export type ChatRequest = {
    user_message: string;
    conversation_id?: string;
    language?: string;
};

export type ChatTimer = {
    backend: number;
    avatarTTS: number;
    avatar: number;
};
